import _ from 'lodash';

const EditorHelper = {
    /**
     * @param {string[]} tags
     * @param editor
     * @returns {*[]}
     */
    generateTagMenu(tags = [], editor) {
        if (tags.length === 0) {
            return [];
        }

        let menu = [];

        tags.forEach((tag) => {
            menu.push({
                type: 'menuitem',
                text: tag,
                onAction: () => editor.insertContent(`[${tag}]`),
            });
        });

        return menu;
    },
    insertCrossReference(object, type, editor, document) {
        const tag = `[Ref id=${object.id} type=${type} document=${document.id}]`;
        editor.insertContent(tag);
    },
    createCrossReferenceTag(entityId, entityType, documentId) {
        return `[Ref id=${entityId} type=${entityType} document=${documentId}]`;
    },
    parseCrossReferenceTag(tagValue) {
        const regexp = /\[Ref id=(.*) type=(.*) document=(.*)\]/g;
        const match = regexp.exec(tagValue);

        return _.slice(match, '1');
    },
};

export default EditorHelper;
